//@ts-nocheck directive
import React, { useState } from "react";
import { UpdateUserProfileType } from "../Types/userProfile";
//import MemberFred from "../../Images/Fred3.jpg";
import styles from "./UserProfile.module.css";
import Video from "../../Images/video-small.png";
import Camera from "../../Images/camera-small.png";
import Events from "../../Images/Events.png";
import Links from "../../Images/Links.png";
import Documents from "../../Images/Documents.png";
import Like from "../../Images/Like.png";
import Comment from "../../Images/Comment.png";
import Share from "../../Images/Share.png";
import PostImage1 from "../../Images/post-image-1.png";
import "../lib/RequireUser/index.css";
import { useNavigate } from "react-router-dom";
import { getDatabase, ref, set } from "firebase/database";
import { auth, app } from "../lib/firebase";
import { doc, getFirestore, updateDoc } from "firebase/firestore";
import CreatePhotoURL from "./CreatePhotoURL";
import UpdateUserPhotoURL from "./UpdateUserPhotoURL";
import WelcomePage from "../WelcomePage/WelcomePage";
import { useAuthState } from "react-firebase-hooks/auth";
import { updateProfile } from "firebase/auth";
import UpdateUserProfileName from "./UpdateUserProfileName";
import photoURL from "../../Images/photoURL.png";
import Upload from "../Cloud/Upload";

interface IProps {
  userProfile: UpdateUserProfileType;
}

const uploadUrl =
  "https://us-central1-footprints-b291f.cloudfunctions.net/uploadFile";
var bodyStyles = document.body.style;
var destFileName = "";
var generationMatchPrecondition = 1;
var filePath = "";
var photoLink = "";
var photoRef = "";
photoLink = localStorage.getItem("myPicture");
var tempUID = localStorage.getItem("userUID")!;

console.log("in UserInfo at the top and photolink = ", photoLink);

function UserInformation({ userProfile }: IProps) {
  console.log("userProfiles " + userProfile);
  console.log("userProfiles id " + userProfile.id); //mmm...this is the doc id, not user id
  const tempUID: string = localStorage.getItem("userUID")!;
  const docID = userProfile;
  const db = getFirestore();
  const [userAbout, setUserAbout] = useState("");
  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");

  const [userProfileLink1, setUserProfileLink1] = useState("");
  const [userProfileLink2, setUserProfileLink2] = useState("");
  const [userProfileLink3, setUserProfileLink3] = useState("");
  const [userProfileLink4, setUserProfileLink4] = useState("");

  const [userPhotoName, setUserPhotoName] = useState(photoLink);
  const [userProfileName, setUserProfileName] = useState("");
  const [userCountry, setUserCountry] = useState(userProfile.userCountry);
  const [userEmail, setUserEmail] = useState("");
  const [userUID, setUserUID] = useState(tempUID);
  const [selectedFile, setSelectedFile] = useState<File | null>(null); // Add state for the selected file
  //var fileInput = document.getElementById("temp_picture");
  //console.log("temp_pic = ", fileInput);

  const sanitizeFileName = (fileName: string): string => {
    // Replace any character that is not a letter, number, or underscore with '_'
    return fileName.replace(/[^a-zA-Z0-9]/g, "_");
  };

  function uploadPhotoName(arg: string) {
    const docRef = doc(db, "userProfiles", userProfile.id);

    var replaceName = arg;
    replaceName = replaceName.replace(/.*[\/\\]/, "");

    console.log(" photo file name = ", replaceName);
    setUserPhotoName(replaceName);
    updateDoc(docRef, {
      userPhotoName: replaceName,
    });
    console.log(" setphoto file name = ", replaceName);
    localStorage.setItem("myPicture", replaceName);
  }

  // Function to upload a photo file
  async function uploadPhotoFile(file: File) {
    // Sanitize the file name
    const sanitizedFileName = sanitizeFileName(file.name);

    // Create a new File object with the sanitized file name
    const sanitizedFile = new File([file], sanitizedFileName, {
      type: file.type,
    });

    const formData = new FormData();
    formData.append("myfile", sanitizedFile);

    try {
      const response = await fetch(uploadUrl, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.statusText}`);
      }

      const result = await response.text(); // Assuming the server returns plain text
      console.log("Upload successful:", result);

      console.log("file name:", file.name);

      // Update photo name state and database record
      const fileName = sanitizedFileName;
      setUserPhotoName(fileName);

      const docRef = doc(db, "userProfiles", userProfile.id);
      await updateDoc(docRef, { userPhotoName: fileName });
      localStorage.setItem("myPicture", fileName);

      if (result === "File uploaded successfully.") {
        const photoUrl = `https://storage.googleapis.com/footprints-b291f.appspot.com/${sanitizedFileName}`;

        // Update state to reflect new photo
        setUserPhotoName(photoUrl);
        UpdateUserPhotoURL(photoUrl);

        // Reload the page if the upload was successful
        // Delay reload by 2 seconds (2000 milliseconds)
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.error("Upload error:", error);
    }
  }

  // Handle file input change event
  function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0];
    if (file) {
      console.log("Selected file:", file);
      setSelectedFile(file); // Store the selected file in state
    }
  }

  // Handle the upload button click
  function handleUploadClick() {
    if (selectedFile) {
      console.log("Preparing to upload file:", selectedFile);
      uploadPhotoFile(selectedFile);
    } else {
      console.log("No file selected for upload.");
    }
  }

  function getSelect(e: ChangeEvent<HTMLSelectElement>) {
    console.log("selectedValue = ", e);
    //const temp = e.currentTarget.selectedIndex;
    let temp = e;

    setUserCountry(temp);
    console.log("temp value for country = ", temp);
  }

  const saveUserProfileChanges: (
    arg0: string,
    arg1: string,
    arg2: string,
    arg3: string,
    arg4: string,
    arg5: string,
    arg6: string,
    arg7: string,
    arg8: string,
    arg9: string,
    arg10: string,
    arg11: string
  ) => void = () => {
    //const db = getDatabase(app);

    console.log("in saveChanges and first name = ", userFirstName);
    console.log("in saveChanges and last name = ", userLastName);
    console.log("in saveChanges and db =  ", db);
    console.log("in saveChanges and userProfile.id = ", userProfile.id);
    console.log("in saveChanges and userPhotoLink = ", userPhotoName);
    const docRef = doc(db, "userProfiles", userProfile.id);
    console.log("in saveChanges and docRef = ", docRef);

    if (userProfileLink1 != "") {
      updateDoc(docRef, {
        userProfileLink1: userProfileLink1,
      });
    } else if (userProfile.userProfileLink1 !== "") {
      updateDoc(docRef, {
        userProfileLink1: userProfile.userProfileLink1,
      });
    } else {
      updateDoc(docRef, {
        userProfileLink1: "",
      });
    }

    if (userProfileLink2 != "") {
      updateDoc(docRef, {
        userProfileLink2: userProfileLink2,
      });
    } else if (userProfile.userProfileLink2 !== "") {
      updateDoc(docRef, {
        userProfileLink2: userProfile.userProfileLink2,
      });
    } else {
      updateDoc(docRef, {
        userProfileLink2: "",
      });
    }

    if (userProfileLink3 != "") {
      updateDoc(docRef, {
        userProfileLink3: userProfileLink3,
      });
    } else if (userProfile.userProfileLink3 !== "") {
      updateDoc(docRef, {
        userProfileLink3: userProfile.userProfileLink3,
      });
    } else {
      updateDoc(docRef, {
        userProfileLink3: "",
      });
    }

    if (userProfileLink4 != "") {
      updateDoc(docRef, {
        userProfileLink4: userProfileLink4,
      });
    } else if (userProfile.userProfileLink4 !== "") {
      updateDoc(docRef, {
        userProfileLink4: userProfile.userProfileLink4,
      });
    } else {
      updateDoc(docRef, {
        userProfileLink4: "",
      });
    }

    if (userAbout != "") {
      updateDoc(docRef, {
        userAbout: userAbout,
      });
    } else if (userProfile.userAbout !== "") {
      updateDoc(docRef, {
        userAbout: userProfile.userAbout,
      });
    } else {
      updateDoc(docRef, {
        userAbout: "",
      });
    }

    if (userCountry != "") {
      updateDoc(docRef, {
        userCountry: userCountry,
      });
    }

    if (userFirstName != "") {
      updateDoc(docRef, {
        userFirstName: userFirstName,
      });
    } else if (userProfile.userFirstName !== "") {
      updateDoc(docRef, {
        userFirstName: userProfile.userFirstName,
      });
    } else {
      updateDoc(docRef, {
        userFirstName: "",
      });
    }

    if (userLastName != "") {
      updateDoc(docRef, {
        userLastName: userLastName,
      });
    } else if (userProfile.userLastName !== "") {
      updateDoc(docRef, {
        userLastName: userProfile.userLastName,
      });
    } else {
      updateDoc(docRef, {
        userLastName: "",
      });
    }

    if (userProfileName != "") {
      localStorage.setItem("userProfileName", userProfileName);
      updateDoc(docRef, {
        userProfileName: userProfileName,
      });
      UpdateUserProfileName(userProfileName);
    } else if (userProfile.userProfileName !== "") {
      updateDoc(docRef, {
        userProfileName: userProfile.userProfileName,
      });
      UpdateUserProfileName(userProfile.userProfileName);
    } else {
      updateDoc(docRef, {
        userProfileName: "",
      });
      UpdateUserProfileName("");
    }

    changeSaveButtonOff();
  };

  function changeSaveButtonOn() {
    bodyStyles.setProperty("--btn-inactive-text", "black");
    bodyStyles.setProperty("--btn-inactive-back", "rgb(175, 201, 250)");
    bodyStyles.setProperty("--btn-inactive-ptr", "pointer");
    bodyStyles.setProperty("--btn-inactive-hv", "rgba(175, 201, 250, 0.758)");
    bodyStyles.setProperty("--btn-inactive-tr", "0.7s");
  }

  function changeSaveButtonOff() {
    bodyStyles.setProperty("--btn-inactive-text", "rgba(129, 142, 164, 0.913)");
    bodyStyles.setProperty("--btn-inactive-back", "rgb(200, 212, 235)");
    bodyStyles.setProperty("--btn-inactive-ptr", "default");
    bodyStyles.setProperty("--btn-inactive-hv", "rgb(200, 212, 235)");
    bodyStyles.setProperty("--btn-inactive-tr", "0s");
  }

  photoRef = UpdateUserPhotoURL(photoLink);
  console.log(" photo ref = ", photoRef);

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <h1 className={styles.header}>User Profile</h1>
          <button
            className={styles.saveButton}
            onClick={() =>
              saveUserProfileChanges(
                userAbout,
                userCountry,
                userFirstName,
                userLastName,
                userPhotoName,
                userProfileName,
                userEmail,
                userUID,
                userProfileLink1,
                userProfileLink2,
                userProfileLink3,
                userProfileLink4
              )
            }
          >
            {" "}
            Save{" "}
          </button>
          <a href="WelcomePage" className={styles.closeAnchor}>
            <button className={styles.closeButton}> Close </button>
          </a>
        </div>
        <div>
          <label className={styles.userLabel}>First Name</label>
          <input
            type="text"
            required
            style={{ paddingLeft: 3, marginLeft: 10 }}
            defaultValue={userProfile.userFirstName}
            onChange={(e) => {
              setUserFirstName(e.target.value);
              console.log(" user first name is ", userFirstName);
              changeSaveButtonOn();
            }}
          />
          <div>
            <label className={styles.userLabel}>Last Name</label>
            <input
              type="text"
              required
              style={{ paddingLeft: 3, marginLeft: 12 }}
              defaultValue={userProfile.userLastName}
              onChange={(e) => {
                setUserLastName(e.target.value);
                changeSaveButtonOn();
              }}
            />
          </div>
          <div>
            <label className={styles.userLabel}>Profile Name</label>
            <input
              type="text"
              required
              style={{ paddingLeft: 3, marginLeft: -3 }}
              defaultValue={userProfile.userProfileName}
              onChange={(e) => {
                setUserProfileName(e.target.value);
                changeSaveButtonOn();
                localStorage.setItem("userProfileName", e.target.value);
              }}
            />
          </div>
        </div>
        <div>
          <label className={styles.userLabel}>Country</label>

          <select
            id="country"
            defaultValue={userCountry}
            name="country"
            class="form-control"
            style={{ marginLeft: 33 }}
            onChange={(e) => {
              getSelect(e.target.value);
              changeSaveButtonOn();
            }}
          >
            <option value="Afghanistan">Afghanistan</option>
            <option value="Åland Islands">Åland Islands</option>
            <option value="Albania">Albania</option>
            <option value="Algeria">Algeria</option>
            <option value="American Samoa">American Samoa</option>
            <option value="Andorra">Andorra</option>
            <option value="Angola">Angola</option>
            <option value="Anguilla">Anguilla</option>
            <option value="Antarctica">Antarctica</option>
            <option value="Antigua and Barbuda">Antigua and Barbuda</option>
            <option value="Argentina">Argentina</option>
            <option value="Armenia">Armenia</option>
            <option value="Aruba">Aruba</option>
            <option value="Australia">Australia</option>
            <option value="Austria">Austria</option>
            <option value="Azerbaijan">Azerbaijan</option>
            <option value="Bahamas">Bahamas</option>
            <option value="Bahrain">Bahrain</option>
            <option value="Bangladesh">Bangladesh</option>
            <option value="Barbados">Barbados</option>
            <option value="Belarus">Belarus</option>
            <option value="Belgium">Belgium</option>
            <option value="Belize">Belize</option>
            <option value="Benin">Benin</option>
            <option value="Bermuda">Bermuda</option>
            <option value="Bhutan">Bhutan</option>
            <option value="Bolivia">Bolivia</option>
            <option value="Bosnia and Herzegovina">
              Bosnia and Herzegovina
            </option>
            <option value="Botswana">Botswana</option>
            <option value="Bouvet Island">Bouvet Island</option>
            <option value="Brazil">Brazil</option>
            <option value="British Indian Ocean Territory">
              British Indian Ocean Territory
            </option>
            <option value="Brunei Darussalam">Brunei Darussalam</option>
            <option value="Bulgaria">Bulgaria</option>
            <option value="Burkina Faso">Burkina Faso</option>
            <option value="Burundi">Burundi</option>
            <option value="Cambodia">Cambodia</option>
            <option value="Cameroon">Cameroon</option>
            <option value="Canada">Canada</option>
            <option value="Cape Verde">Cape Verde</option>
            <option value="Cayman Islands">Cayman Islands</option>
            <option value="Central African Republic">
              Central African Republic
            </option>
            <option value="Chad">Chad</option>
            <option value="Chile">Chile</option>
            <option value="China">China</option>
            <option value="Christmas Island">Christmas Island</option>
            <option value="Cocos (Keeling) Islands">
              Cocos (Keeling) Islands
            </option>
            <option value="Colombia">Colombia</option>
            <option value="Comoros">Comoros</option>
            <option value="Congo">Congo</option>
            <option value="Congo, The Democratic Republic of The">
              Congo, The Democratic Republic of The
            </option>
            <option value="Cook Islands">Cook Islands</option>
            <option value="Costa Rica">Costa Rica</option>
            <option value="Cote d'Ivoire">Cote d'Ivoire</option>
            <option value="Croatia">Croatia</option>
            <option value="Cuba">Cuba</option>
            <option value="Cyprus">Cyprus</option>
            <option value="Czech Republic">Czech Republic</option>
            <option value="Denmark">Denmark</option>
            <option value="Djibouti">Djibouti</option>
            <option value="Dominica">Dominica</option>
            <option value="Dominican Republic">Dominican Republic</option>
            <option value="Ecuador">Ecuador</option>
            <option value="Egypt">Egypt</option>
            <option value="El Salvador">El Salvador</option>
            <option value="Equatorial Guinea">Equatorial Guinea</option>
            <option value="Eritrea">Eritrea</option>
            <option value="Estonia">Estonia</option>
            <option value="Ethiopia">Ethiopia</option>
            <option value="Falkland Islands (Malvinas)">
              Falkland Islands (Malvinas)
            </option>
            <option value="Faroe Islands">Faroe Islands</option>
            <option value="Fiji">Fiji</option>
            <option value="Finland">Finland</option>
            <option value="France">France</option>
            <option value="French Guiana">French Guiana</option>
            <option value="French Polynesia">French Polynesia</option>
            <option value="French Southern Territories">
              French Southern Territories
            </option>
            <option value="Gabon">Gabon</option>
            <option value="Gambia">Gambia</option>
            <option value="Georgia">Georgia</option>
            <option value="Germany">Germany</option>
            <option value="Ghana">Ghana</option>
            <option value="Gibraltar">Gibraltar</option>
            <option value="Greece">Greece</option>
            <option value="Greenland">Greenland</option>
            <option value="Grenada">Grenada</option>
            <option value="Guadeloupe">Guadeloupe</option>
            <option value="Guam">Guam</option>
            <option value="Guatemala">Guatemala</option>
            <option value="Guernsey">Guernsey</option>
            <option value="Guinea">Guinea</option>
            <option value="Guinea-bissau">Guinea-bissau</option>
            <option value="Guyana">Guyana</option>
            <option value="Haiti">Haiti</option>
            <option value="Heard Island and Mcdonald Islands">
              Heard Island and Mcdonald Islands
            </option>
            <option value="Holy See (Vatican City State)">
              Holy See (Vatican City State)
            </option>
            <option value="Honduras">Honduras</option>
            <option value="Hong Kong">Hong Kong</option>
            <option value="Hungary">Hungary</option>
            <option value="Iceland">Iceland</option>
            <option value="India">India</option>
            <option value="Indonesia">Indonesia</option>
            <option value="Iran, Islamic Republic of">Iran</option>
            <option value="Iraq">Iraq</option>
            <option value="Ireland">Ireland</option>
            <option value="Isle of Man">Isle of Man</option>
            <option value="Israel">Israel</option>
            <option value="Italy">Italy</option>
            <option value="Jamaica">Jamaica</option>
            <option value="Japan">Japan</option>
            <option value="Jersey">Jersey</option>
            <option value="Jordan">Jordan</option>
            <option value="Kazakhstan">Kazakhstan</option>
            <option value="Kenya">Kenya</option>
            <option value="Kiribati">Kiribati</option>
            <option value="Korea, Democratic People's Republic of">
              North Korea
            </option>
            <option value="Korea, Republic of">South Korea</option>
            <option value="Kuwait">Kuwait</option>
            <option value="Kyrgyzstan">Kyrgyzstan</option>
            <option value="Lao People's Democratic Republic">Laos</option>
            <option value="Latvia">Latvia</option>
            <option value="Lebanon">Lebanon</option>
            <option value="Lesotho">Lesotho</option>
            <option value="Liberia">Liberia</option>
            <option value="Libyan Arab Jamahiriya">
              Libyan Arab Jamahiriya
            </option>
            <option value="Liechtenstein">Liechtenstein</option>
            <option value="Lithuania">Lithuania</option>
            <option value="Luxembourg">Luxembourg</option>
            <option value="Macao">Macao</option>
            <option value="Macedonia">Macedonia</option>
            <option value="Madagascar">Madagascar</option>
            <option value="Malawi">Malawi</option>
            <option value="Malaysia">Malaysia</option>
            <option value="Maldives">Maldives</option>
            <option value="Mali">Mali</option>
            <option value="Malta">Malta</option>
            <option value="Marshall Islands">Marshall Islands</option>
            <option value="Martinique">Martinique</option>
            <option value="Mauritania">Mauritania</option>
            <option value="Mauritius">Mauritius</option>
            <option value="Mayotte">Mayotte</option>
            <option value="Mexico">Mexico</option>
            <option value="Micronesia, Federated States of">
              Micronesia, Federated States of
            </option>
            <option value="Moldova, Republic of">Moldova, Republic of</option>
            <option value="Monaco">Monaco</option>
            <option value="Mongolia">Mongolia</option>
            <option value="Montenegro">Montenegro</option>
            <option value="Montserrat">Montserrat</option>
            <option value="Morocco">Morocco</option>
            <option value="Mozambique">Mozambique</option>
            <option value="Myanmar">Myanmar</option>
            <option value="Namibia">Namibia</option>
            <option value="Nauru">Nauru</option>
            <option value="Nepal">Nepal</option>
            <option value="Netherlands">Netherlands</option>
            <option value="New Caledonia">New Caledonia</option>
            <option value="New Zealand">New Zealand</option>
            <option value="Nicaragua">Nicaragua</option>
            <option value="Niger">Niger</option>
            <option value="Nigeria">Nigeria</option>
            <option value="Niue">Niue</option>
            <option value="Norfolk Island">Norfolk Island</option>
            <option value="Northern Mariana Islands">
              Northern Mariana Islands
            </option>
            <option value="Norway">Norway</option>
            <option value="Oman">Oman</option>
            <option value="Pakistan">Pakistan</option>
            <option value="Palau">Palau</option>
            <option value="Palestinian Authority">Palestinian Authority</option>
            <option value="Panama">Panama</option>
            <option value="Papua New Guinea">Papua New Guinea</option>
            <option value="Paraguay">Paraguay</option>
            <option value="Peru">Peru</option>
            <option value="Philippines">Philippines</option>
            <option value="Pitcairn">Pitcairn</option>
            <option value="Poland">Poland</option>
            <option value="Portugal">Portugal</option>
            <option value="Puerto Rico">Puerto Rico</option>
            <option value="Qatar">Qatar</option>
            <option value="Reunion">Reunion</option>
            <option value="Romania">Romania</option>
            <option value="Russian Federation">Russia</option>
            <option value="Rwanda">Rwanda</option>
            <option value="Saint Helena">Saint Helena</option>
            <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
            <option value="Saint Lucia">Saint Lucia</option>
            <option value="Saint Pierre and Miquelon">
              Saint Pierre and Miquelon
            </option>
            <option value="Saint Vincent and The Grenadines">
              Saint Vincent and The Grenadines
            </option>
            <option value="Samoa">Samoa</option>
            <option value="San Marino">San Marino</option>
            <option value="Sao Tome and Principe">Sao Tome and Principe</option>
            <option value="Saudi Arabia">Saudi Arabia</option>
            <option value="Senegal">Senegal</option>
            <option value="Serbia">Serbia</option>
            <option value="Seychelles">Seychelles</option>
            <option value="Sierra Leone">Sierra Leone</option>
            <option value="Singapore">Singapore</option>
            <option value="Slovakia">Slovakia</option>
            <option value="Slovenia">Slovenia</option>
            <option value="Solomon Islands">Solomon Islands</option>
            <option value="Somalia">Somalia</option>
            <option value="South Africa">South Africa</option>
            <option value="South Georgia and The South Sandwich Islands">
              South Georgia and The South Sandwich Islands
            </option>
            <option value="Spain">Spain</option>
            <option value="Sri Lanka">Sri Lanka</option>
            <option value="Sudan">Sudan</option>
            <option value="Suriname">Suriname</option>
            <option value="Svalbard and Jan Mayen">
              Svalbard and Jan Mayen
            </option>
            <option value="Swaziland">Swaziland</option>
            <option value="Sweden">Sweden</option>
            <option value="Switzerland">Switzerland</option>
            <option value="Syrian Arab Republic">Syria</option>
            <option value="Taiwan">Taiwan</option>
            <option value="Tajikistan">Tajikistan</option>
            <option value="Tanzania, United Republic of">
              Tanzania, United Republic of
            </option>
            <option value="Thailand">Thailand</option>
            <option value="Timor-leste">Timor-leste</option>
            <option value="Togo">Togo</option>
            <option value="Tokelau">Tokelau</option>
            <option value="Tonga">Tonga</option>
            <option value="Trinidad and Tobago">Trinidad and Tobago</option>
            <option value="Tunisia">Tunisia</option>
            <option value="Turkey">Turkey</option>
            <option value="Turkmenistan">Turkmenistan</option>
            <option value="Turks and Caicos Islands">
              Turks and Caicos Islands
            </option>
            <option value="Tuvalu">Tuvalu</option>
            <option value="Uganda">Uganda</option>
            <option value="Ukraine">Ukraine</option>
            <option value="United Arab Emirates">United Arab Emirates</option>
            <option value="United Kingdom">United Kingdom</option>
            <option value="United States">United States</option>
            <option value="United States Minor Outlying Islands">
              United States Minor Outlying Islands
            </option>
            <option value="Uruguay">Uruguay</option>
            <option value="Uzbekistan">Uzbekistan</option>
            <option value="Vanuatu">Vanuatu</option>
            <option value="Venezuela">Venezuela</option>
            <option value="Viet Nam">Vietnam</option>
            <option value="Virgin Islands, British">
              Virgin Islands, British
            </option>
            <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
            <option value="Wallis and Futuna">Wallis and Futuna</option>
            <option value="Western Sahara">Western Sahara</option>
            <option value="Yemen">Yemen</option>
            <option value="Zambia">Zambia</option>
            <option value="Zimbabwe">Zimbabwe</option>
          </select>
        </div>
        <div>
          <label className={styles.userLabel}>Email</label>
          <input
            style={{
              backgroundColor: "Gainsboro",
              paddingLeft: 3,
              marginLeft: 49,
            }}
            type="text"
            readOnly
            inputMode="none"
            defaultValue={userProfile.userEmail}
            onChange={(e) => {
              setUserEmail(e.target.value);
            }}
          />
        </div>
        <div>
          <label className={styles.userLabel}>Photo</label>
          <img
            className={styles.userPhoto}
            src={photoRef}
            alt=""
            style={{
              paddingTop: 20,
              paddingLeft: 20,
              paddingRight: 20,
              height: 200,
              objectFit: "scale-down",
              marginLeft: 28,
            }}
          />
          <label className={styles.userLabel}>
            {userProfile.userPhotoName}
          </label>
          <div className={styles.uploadButton}>
            <input
              type="file"
              name="myfile"
              size={50}
              id="myfile"
              onChange={handleFileChange}
              style={{
                marginLeft: 10,
                paddingLeft: 3,
                marginTop: 10,
              }}
            />
            <button
              type="button"
              className={styles.photoSubmitButton}
              onClick={handleUploadClick}
            >
              Upload
            </button>
          </div>
        </div>
        <br />
        <div className={styles.aimLabel}>
          <label>About...(useful for journals' "About the Author")</label>
          <textarea
            className={styles.messageText}
            style={{
              paddingLeft: 3,
              marginLeft: 30,
              width: 400,
              height: 170,
            }}
            defaultValue={userProfile.userAbout}
            onChange={(e) => {
              setUserAbout(e.target.value);
              changeSaveButtonOn();
            }}
          />
        </div>

        <div className={styles.userLabel}>
          <label>Profile Links e.g. ResearchGate</label>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 140,
            }}
            type="text"
            defaultValue={userProfile.userProfileLink1}
            onChange={(e) => {
              setUserProfileLink1(e.target.value);
              changeSaveButtonOn();
            }}
          />
          <a
            href={userProfile.userProfileLink1}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button
              style={{
                width: 50,
                display: "inline-grid",
                marginLeft: 10,
                backgroundColor: "Gainsboro",
                borderRadius: 10,
              }}
            >
              Open
            </button>
          </a>
        </div>

        <div className={styles.userLabel}>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 365,
            }}
            type="text"
            defaultValue={userProfile.userProfileLink2}
            onChange={(e) => {
              setUserProfileLink2(e.target.value);
              changeSaveButtonOn();
            }}
          />
          <a
            href={userProfile.userProfileLink2}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button
              style={{
                width: 50,
                display: "inline-grid",
                marginLeft: 10,
                backgroundColor: "Gainsboro",
                borderRadius: 10,
              }}
            >
              Open
            </button>
          </a>
        </div>

        <div className={styles.userLabel}>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 365,
            }}
            type="text"
            defaultValue={userProfile.userProfileLink3}
            onChange={(e) => {
              setUserProfileLink3(e.target.value);
              changeSaveButtonOn();
            }}
          />
          <a
            href={userProfile.userProfileLink3}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button
              style={{
                width: 50,
                display: "inline-grid",
                marginLeft: 10,
                backgroundColor: "Gainsboro",
                borderRadius: 10,
              }}
            >
              Open
            </button>
          </a>
        </div>

        <div className={styles.userLabel}>
          <input
            style={{
              paddingLeft: 3,
              width: 400,
              marginLeft: 365,
            }}
            type="text"
            defaultValue={userProfile.userProfileLink4}
            onChange={(e) => {
              setUserProfileLink4(e.target.value);
              changeSaveButtonOn();
            }}
          />
          <a
            href={userProfile.userProfileLink4}
            target="_blank"
            style={{ display: "inline-grid" }}
          >
            <button
              style={{
                width: 50,
                display: "inline-grid",
                marginLeft: 10,
                backgroundColor: "Gainsboro",
                borderRadius: 10,
              }}
            >
              Open
            </button>
          </a>
        </div>
      </div>
    </>
  );
}

export default UserInformation;
